import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-issue-credit-voucher-paymt-reciept-brifly-report',
  templateUrl: './issue-credit-voucher-paymt-reciept-brifly-report.component.html',
  styleUrls: ['./issue-credit-voucher-paymt-reciept-brifly-report.component.scss'],
})
export class IssueCreditVoucherPaymtRecieptBriflyReportComponent implements OnInit {

  startDate: any;
  endDate: any;
  repName: any;
  issueName: any;
  issueDates: any;
  offRepName: any;
  reportType:any;

  advtBrieflyFormBeans: any[] = [];
  advtBrieflyTotal: number = 0;

  constructor(
    private dialogRef: MatDialogRef<IssueCreditVoucherPaymtRecieptBriflyReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toaster: ToastrService
  ) {
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.repName = data.repName;
    this.issueName = data.issuename;
    this.issueDates = data.issueDates;
    this.offRepName = data.offRepName;
    this.reportType=data.reportType;

    console.log('Start Date:', this.startDate);
    console.log('End Date:', this.endDate);
    console.log('Rep Name:', this.repName);
    console.log('Issue Name:', this.issueName);
    console.log('Issue Date:', this.issueDates);
    console.log('Off Rep Name:', this.offRepName);
    console.log('reportType:',this.reportType);
  }

  ngOnInit(): void {
    const req = {
 
      rep_name: this.repName,
      startDate: this.startDate,
      endDate: this.endDate,
      off_rep_name: this.offRepName,
      issue_name: this.issueName,
      issue_Date: this.issueDates
    
    };
    this.service.getissueOfficerBriefly1(req).subscribe(
      (data: any) => {
        console.log("Briefly1 Data =", data);
        this.advtBrieflyFormBeans = data;
        this.advtBrieflyTotal = 0;

        for (let entry of this.advtBrieflyFormBeans) {
          this.advtBrieflyTotal += parseFloat(entry.total_amt) || 0;
        }
      },
      (error) => {
        console.error('Error fetching briefly data:', error);
        this.toaster.error('Failed to load brief report', 'Error');
      }
    );
  }

exportExcel(fileName: string) {
  const element = document.getElementById('print-section');
  if (!element) {
    this.toaster.error('Table not found!');
    return;
  }

  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  XLSX.writeFile(wb, `${fileName}.xlsx`);
}
}
